import { ReactNode, useEffect, useState } from "react"
import { classNames, classNamesOrEmpty } from "../../style/common"
import { Size } from "../../models/Size"
import { FIREBASE_STORAGE_URL } from "../../app-settings"

export type CardImageWithPlaceholderProps = {
    imagePath: string,
    serial: string,
    cardName: string,
    overlay?: ReactNode,
    footer?: ReactNode,
    rounded?: Size,
    hidePlaceholderText?: boolean,
    classNames?: {
        container?: string | undefined,
        image?: string | undefined,
        cardBack?: string | undefined
    }
}

const roundedSizeMap: Record<Size, string> = {
    "xs": "",
    "sm": ".125rem",
    "md": ".375rem",
    "lg": ".5rem",
    "xl": ".75rem",
    "2xl": "1rem"
}

const defaultRoundedSize = roundedSizeMap.md;

export function ModernCardImage(props: CardImageWithPlaceholderProps) {
    const [rounded, setRounded] = useState<string>(defaultRoundedSize);

    useEffect(() => {
        setRounded(props.rounded ? roundedSizeMap[props.rounded] : defaultRoundedSize);
    }, [props.rounded]);

    return (
        <div className={classNames("relative inline-block w-full", props.classNames?.container)} style={{ aspectRatio: "143/200" }}>
            {
                !!props.overlay && props.overlay
            }
            <img
                style={{ aspectRatio: "143/200", zIndex: "2", borderRadius: rounded }}
                src={`${FIREBASE_STORAGE_URL}/images/cards/${props.imagePath}.jpg`}
                alt={`${props.cardName} image`}
                loading="lazy"
                className={`relative w-full ${classNamesOrEmpty(props.classNames?.image)}`} />

            {
                !props.hidePlaceholderText &&
                <div className={classNames("absolute bottom-[13%] text-white z-[1] text-center w-full")}>
                    <div>{props.serial}</div>
                    <div>{props.cardName}</div>
                </div>
            }

            <img
                className={classNames(`absolute top-0 p-[2px]`, props.classNames?.cardBack)}
                style={{ aspectRatio: "143/200", borderRadius: rounded }}
                src={`${FIREBASE_STORAGE_URL}/images/cards/card-back.jpg`} />
        </div>
    )
}